import React from 'react';

type LoginOptionsListItemProps = { children: React.ReactNode };

const LoginOptionsListItem = ({ children }: LoginOptionsListItemProps) => {
	return <li className="vtex-login-2-x-optionsListItem optionsListItem mb3">{children}</li>;
};

export default LoginOptionsListItem;
